import { useEffect, useState } from "react";
import type { Embodiment, Tip } from "@/api";
import type { UserRole } from "@/app";
import { EmbodimentComposerModal, type EmbodimentComposerSource } from "./EmbodimentComposerModal";
import { EmbodimentSourceChoiceDialog } from "./EmbodimentSourceChoiceDialog";

export type EmbodimentComposerFlowProps = {
  open: boolean;
  role: UserRole | null;
  // 현재 tip 선택이다(EE 와 독립). 컴포저가 그대로 받는다.
  currentTip: Tip | null;
  onClose: () => void;
  onApply: (embodiment: Embodiment, tip: Tip | null) => void;
};

// '새 Embodiment' 진입 흐름: 소스 선택 창(새로 작성 / 기존에서 가져오기) → 컴포저.
// 편집 진입(상세 → 편집, 딥링크)은 이 흐름을 쓰지 않는다. EmbodimentComposerModal 을
// edit 소스로 직접 연다.
export function EmbodimentComposerFlow({
  open,
  role,
  currentTip,
  onClose,
  onApply,
}: EmbodimentComposerFlowProps) {
  const [source, setSource] = useState<EmbodimentComposerSource | null>(null);

  // 열릴 때마다 소스 선택부터 다시 시작한다.
  useEffect(() => {
    if (!open) {
      setSource(null);
    }
  }, [open]);

  if (!open) {
    return null;
  }
  if (source === null) {
    return <EmbodimentSourceChoiceDialog open onClose={onClose} onChoose={setSource} />;
  }
  return (
    <EmbodimentComposerModal
      open
      role={role}
      source={source}
      currentTip={currentTip}
      onClose={onClose}
      onApply={onApply}
    />
  );
}
